export enum CurrencyType {
	FIAT = "FIAT",
	CRYPTO = "CRYPTO",
}
